export const PRE_CALL_SMS_DEFAULT_MINUTES = 5;
export const PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME = 'there';
export const PRE_CALL_SMS_FALLBACK_AGENT_NAME = 'Customer Service';

// Twilio blocks our outbound SMS to anything outside these country calling codes.
export const PRE_CALL_SMS_SUPPORTED_COUNTRIES: ReadonlyArray<{ callingCode: string; demonym: string }> = [
  { callingCode: '61', demonym: 'Australian' },
];

// Never rename after release: it would split historical dashboard reporting.
export const PRE_CALL_SMS_FEATURE_ID = 'pre-call-sms';
